import React, { useContext } from 'react';
import firebase from '../firebase';
import { UserContext } from './UserContext';
import { ThemeContext } from './ThemeContext';
import useIsOnline from '../hooks/useIsOnline';
import LostConnection from './LostConnection';
import GoogleLogo from '../btn_google_dark_normal_ios.svg';

function SignIn() {

    const [user] = useContext(UserContext);
    const [isLight, setIsLight] = useContext(ThemeContext);
    const isOnline = useIsOnline();

    function googleSignIn() {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithRedirect(provider);
    }

    function signOut() {
        firebase.auth().signOut();
    }

    if(!isOnline) {
        return(
            <LostConnection />
        )
    }

    return (
        <div className="page outerSignin">
            <div className="signin">
                <h2>In Order To Update the Status of any Trails you need to be signed in</h2>
                {user && <h3>You Are Currently Signed in As {user.displayName}</h3>}
                <button className="signin__button signin__button--google" onClick={googleSignIn}> <img className="googleLogo" src={GoogleLogo} alt="googleLogo"/> <p className="buttonText">Sign in with Google</p></button>
                {user && <button className="signin__button" onClick={signOut}>Sign out</button>}
                <button className="signin__button" onClick={() => setIsLight(!isLight)}>change theme</button>
            </div>
        </div>
    )
}

export default SignIn;